import React from 'react';
import SvgIcon from '../_SvgIcon';
const factoryPaymentIcon = (IconComp) => {
    const Component = (props, ref) => {
        return React.createElement(SvgIcon, Object.assign({ IconComp: IconComp }, props, { forwardedRef: ref }));
    };
    return React.memo(React.forwardRef(Component));
};
export default factoryPaymentIcon;
//# sourceMappingURL=factoryPaymentIcon.js.map